import { ConstantProvider } from './constants';
import {Injectable} from '@angular/core';
import {Http, URLSearchParams, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import {SettingsProvider} from './settings';

@Injectable()
export class AuthenticationProvider {
    public authenticated: boolean = false;
    public token: string = '';
    public funcoes:any = [];
    public session: any = {};

    constructor(public http: Http,
                public settings: SettingsProvider,
                public constants : ConstantProvider) {
    }

    authenticate(usuario) {
        const body = new URLSearchParams();
        body.append('login', usuario.name);
        body.append('password', usuario.password);
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        return new Promise((resolve, reject) => {
            this
                .http
                .post(this.constants.API_URL + "/login", body, {headers: headers})
                .subscribe((data: any) => {
                    let resp = data.json();
                    if(resp.success) {
                        this.token = resp.token;
                        this.session = resp;
                        this.authenticated = true;

                        let objSession:any = {
                            message: this.session.message,
                            success: this.session.success,
                            token: this.session.token
                        };
                        this.storeUserCredentials(objSession).then(r => {});
                        //this.settings.saveSetting('infocon', this.session.info.data);
                        this.settings.saveSetting('infouser', this.session.infouser);
                        resolve(this.session);
                    } else {
                        resolve(resp);
                    }
                }, (err) => {
                    reject(err.json())
                });
        });
    }

    storeUserCredentials(ssn) {
        return new Promise(resolve => {
            this.authenticated = true;
            ssn.authenticated = true;
            this.settings.saveSetting('session', ssn);
        });
    }

    loadUserCredentials() {
        return new Promise(resolve => {
            this.settings
                .loadSetting("session")
                .then((ssn:any) => {
                    this.session = ssn;
                    if (this.session != undefined) {
                        this.authenticated = this.session.authenticated;
                    }
                    resolve(ssn);
                });
        });
    }

    destroyUserCredentials() {
        this.authenticated = false;
        this.token = '';
        this.funcoes = [];
        this.session = {};
        return new Promise(resolve => {
            this.settings.eraseData();
            resolve(true);
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/authentication.ts